export default "__VITE_ASSET__C9N3uuqg__"